<!-- <ng-container>
    <router-outlet>

    </router-outlet>
</ng-container> -->

<div class="container-fluid p-0">
  <router-outlet>
    <ngx-ui-loader></ngx-ui-loader>
  </router-outlet>
    <!-- if need to full screen middle content then add full_screen_content class -->
    <!-- <div *ngIf="show; then isCustomLayout else layoutEnabled">
    </div>
    <ng-template #isCustomLayout>
      <div class="maincontentsection">
      <router-outlet>
        <app-header></app-header>
        <app-side-bar></app-side-bar>
      </router-outlet>
    </div>
    </ng-template>
    <ng-template #layoutEnabled>
      <router-outlet>
      </router-outlet>
    </ng-template> -->

</div>
